import { TextField } from "@mui/material";
import { Controller, type Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { ResourceFormValues } from "@/types";

type FormNs = "projects" | "metrics";

interface ResourceFormFieldsProps {
  control: Control<ResourceFormValues>;
  ns: FormNs;
}

export function ResourceFormFields({ control, ns }: ResourceFormFieldsProps) {
  const { t } = useTranslation();

  const label = (key: keyof ResourceFormValues) => t(`${ns}.${key}`);

  return (
    <>
      <Controller
        name="name"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <TextField {...field} label={label("name")} required fullWidth />
        )}
      />
      <Controller
        name="shortName"
        control={control}
        render={({ field }) => (
          <TextField {...field} label={label("shortName")} fullWidth />
        )}
      />
      <Controller
        name="displayName"
        control={control}
        render={({ field }) => (
          <TextField {...field} label={label("displayName")} fullWidth />
        )}
      />
      <Controller
        name="slug"
        control={control}
        render={({ field }) => (
          <TextField {...field} label={label("slug")} fullWidth />
        )}
      />
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label={label("description")}
            multiline
            rows={3}
            fullWidth
          />
        )}
      />
    </>
  );
}
